'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _wixDataConnectorSettings = require('./wix-data-connector-settings');

Object.defineProperty(exports, 'WixDataConnectorSettings', {
  enumerable: true,
  get: function get() {
    return _wixDataConnectorSettings.WixDataConnectorSettings;
  }
});